"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganizationList = void 0;
const IsomorphicClerkContext_1 = require("../contexts/IsomorphicClerkContext");
const UserContext_1 = require("../contexts/UserContext");
const useOrganizationList = () => {
    const isomorphicClerk = (0, IsomorphicClerkContext_1.useIsomorphicClerkContext)();
    const user = (0, UserContext_1.useUserContext)();
    // TODO: Properly check for SSR user values
    if (!isomorphicClerk.loaded || !user) {
        return { isLoaded: false, organizationList: undefined, createOrganization: undefined, setActive: undefined };
    }
    const clerk = isomorphicClerk;
    return {
        isLoaded: true,
        organizationList: createOrganizationList(user.organizationMemberships),
        setActive: clerk.setActive,
        createOrganization: clerk.createOrganization,
    };
};
exports.useOrganizationList = useOrganizationList;
function createOrganizationList(organizationMemberships) {
    return organizationMemberships.map(organizationMembership => ({
        membership: organizationMembership,
        organization: organizationMembership.organization,
    }));
}
